import FormViewer from 'Components/FormViewer';
import SimpleList from 'Components/SimpleList';
import React from 'react';
import { useSelector } from 'react-redux';
import { unixToDate } from 'utils/date';
import displayMetadata from 'utils/displayMetadata';

const Component = props => {
    const measurement = useSelector(state => state.measurements.models[props.measurement.id]);
    const measurements = useSelector(state => state.measurements.models);
    const device = useSelector(state => state.devices.models[measurement.device_id]);
    const indicator = useSelector(state => state.indicators.models[measurement.indicator_id]);

    const properties = [
        { label: 'ID', content: () => measurement.id },
        { label: 'Name', content: model => model.name },
        { label: 'Activated At', content: model => unixToDate(model.created_at) },
        { label: 'Stopped At', content: model => model.stopped_at ? unixToDate(model.stopped_at) : '-' },
        { label: 'Indicator', content: () => indicator ? indicator.name : '-' },
        { label: 'Creation', content: model => `${model.creator_name} @ ${unixToDate(model.created_at)}` },
        { label: 'Last Modification', content: model => `${model.updater_name} @ ${unixToDate(model.updated_at)}` }
    ];

    if (device.in_protocol_name === 'Digital') {
        properties.splice(2, 0, { label: 'Port Name', content: model => model.port_name || '-' });
    }

    if (measurement.input_kind === 'wise_button') {
        properties.splice(7, 0, {
            label: 'Relays', content: model => {
                const relays = Object.values(measurements).filter(measurement => measurement.wise_button_id === model.id);

                if (relays.length === 0) {
                    return '-';
                }

                return (
                    <React.Fragment>
                        {relays.map(relay => <div key={relay.id}>{relay.name}<br/></div>)}
                    </React.Fragment>
                );
            }
        });
    }

    let attributes = properties.map(({ label, content, styleLabel }) => ({
        label, content: content(measurement), styleLabel
    }));

    attributes = [...attributes, ...displayMetadata(measurement)];

    return (
        <FormViewer label="Measurement Details">
            <SimpleList content={attributes}/>
        </FormViewer>
    );
};

export default Component;
